var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useDareDropApi } from 'root/src/client/v2/common/hooks/useDareDropApi';
import { useInfiniteQuery, useMutation, useQuery } from '@tanstack/react-query';
import { GiveawayProjection } from '@daredrop-com/rewards-api-contract';
import { giveawayEndpointIds } from 'root/src/shared/giveaways/giveaways.constants';
import { giveawaysMutationKeys, giveawaysQueryKeys } from 'root/src/shared/giveaways/giveaways.keys';
import { GET_GIVEAWAYS_PAGED_BASE_QUERY_PARAMS, GET_VOUCHERS_COUNT_BASE_PARAMS, GIVEAWAYS_DEFAULT_LIMIT, } from 'root/src/client/v2/giveaways/features/GiveawayHistory/fixtures/giveaway-history.fixture';
export const useGiveawaysQuery = (params) => {
    const { fetcher } = useDareDropApi();
    return useQuery({
        queryKey: giveawaysQueryKeys.giveawaysQueryKeySelector(),
        queryFn: () => __awaiter(void 0, void 0, void 0, function* () {
            var _a;
            return fetcher({
                endpointId: giveawayEndpointIds.GET_USER_GIVEAWAYS,
                payload: {
                    userId: params.payload.userId,
                    limit: (_a = params.payload.limit) !== null && _a !== void 0 ? _a : GIVEAWAYS_DEFAULT_LIMIT,
                },
            });
        }),
    });
};
export function useCreateGiveawayMutation() {
    const { fetcher } = useDareDropApi();
    return useMutation({
        mutationKey: giveawaysMutationKeys.createGiveawayMutationKeySelector(),
        mutationFn: (data) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            return fetcher({
                endpointId: giveawayEndpointIds.CREATE_GIVEAWAY,
                payload: {
                    durationTime: data.durationTime,
                    repeatTimes: (_a = data.repeatTimes) !== null && _a !== void 0 ? _a : undefined,
                    configId: data.configId,
                },
            });
        }),
    });
}
export function useGiveawaysPagedQuery(params) {
    const { fetcher } = useDareDropApi();
    return useInfiniteQuery(Object.assign(Object.assign({}, GET_GIVEAWAYS_PAGED_BASE_QUERY_PARAMS), { queryFn: ({ pageParam }) => {
            return fetcher({
                endpointId: giveawayEndpointIds.GET_USER_GIVEAWAYS,
                payload: {
                    userId: params.payload.userId,
                    offset: pageParam * GIVEAWAYS_DEFAULT_LIMIT,
                    limit: GIVEAWAYS_DEFAULT_LIMIT,
                    projection: GiveawayProjection.Creator,
                },
            });
        } }));
}
export function useVouchersCountQuery(params) {
    const { fetcher } = useDareDropApi();
    return useQuery(Object.assign(Object.assign(Object.assign({}, GET_VOUCHERS_COUNT_BASE_PARAMS), { queryFn: () => __awaiter(this, void 0, void 0, function* () {
            return fetcher({
                endpointId: giveawayEndpointIds.GET_VOUCHERS_COUNT,
                payload: {
                    giveawayOwnerId: params.payload.giveawayOwnerId,
                },
            });
        }) }), params));
}
export function useGiveawayStatisticsQuery() {
    const { fetcher } = useDareDropApi();
    return useQuery({
        queryKey: giveawaysQueryKeys.giveawaysStatisticsQueryKeySelector(),
        queryFn: () => __awaiter(this, void 0, void 0, function* () {
            return fetcher({
                endpointId: giveawayEndpointIds.GET_USER_GIVEAWAY_STATISTICS,
            });
        }),
    });
}
